<div class="flex flex-column gap-5 min-h-screen justify-content-between">
  <app-partner-portal-top-nav-bar></app-partner-portal-top-nav-bar>
  <div class="flex-1 overflow-y-visible">
    <router-outlet></router-outlet>
  </div>
</div>

<p-toast position="bottom-right" key="notification" [baseZIndex]="5000" styleClass="custom-notification-toast">
    <ng-template let-message pTemplate="message">
        <div class="flex flex-column w-full" style="flex: 1">
            <div class="flex align-items-center gap-3 mb-2">
                <p-avatar [image]="message?.data?.image || 'assets/images/default-profile.png'" shape="circle"
                    size="large" styleClass="border-circle shadow-1" />
                <span class="font-bold text-900 text-lg">
                    {{ message?.data?.name || 'Notification' }}
                </span>
            </div>
            <div class="font-medium text-700 line-height-3 mb-3">
                {{ message.summary }}
            </div>
            <div class="flex justify-content-end" *ngIf="message?.data?.route && message?.data?.route!=''">
                <p-button size="small" styleClass="btn-notification-view" label="View Details" icon="pi pi-arrow-right"
                    iconPos="right" (onClick)="openNotification(message?.data?.route)" />
            </div>
        </div>
    </ng-template>
</p-toast>
